import { v4 as uuid } from "uuid";

export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY hh:mm A";

/** Generates a new UUID used as the ML analytics session id. */
export const generateSessionId = () => uuid();

export const PROMPT_STATUS_CONFIG = {
  done: {
    label: "Done",
    className: "done",
  },
  failed: {
    label: "Failed",
    className: "failed",
  },
  pending: {
    label: "Pending",
    className: "pending",
  },
};

/** Maps API numeric or string status values to done, failed, or pending. @param {number|string|null} status - raw prompt status */
export const normalizePromptStatus = (status) => {
  if (status === 1 || status === "done") return "done";
  if (status === 0 || status === "failed") return "failed";
  if (status === "in_process" || status === "pending") return "pending";
  return status || null;
};
